module.exports = __webpack_public_path__ + "static/media/ro.0ab28634.svg";